import theme from '../../themes/index.en';

const { palette, spacing, typography } = theme;


const BreadcrumbMenuStyles ={
    breadcrumb: {
      padding: theme.spacing(1, 2),
      margin: 0,
      listStyle: 'none',
      backgroundColor: theme.palette.divider,
      borderRadius: theme.shape.borderRadius,
      display: 'flex',
      flexWrap: 'wrap' as 'wrap',
    },
    
    breadcrumbItem: {
      display: 'inline-block',
      marginRight: theme.spacing(1),
    },
    
    lastBreadcrumbItem: {
      marginRight: 0,
    },
    
    breadcrumbSeparator: {
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      color: theme.palette.primary.light,
    },
    
    breadcrumbLink: {
      color: theme.palette.primary.light,
      textDecoration: 'none',
      transition: 'color 0.3s',
      '&:hover': {
        color: theme.palette.secondary.main,
      },
    },
    
    breadcrumbItemActive: {
      color: theme.palette.action.disabled, 
    },
  };
   

export default BreadcrumbMenuStyles;
